export default __webpack_public_path__ + "static/media/doctorprox.07ea9cb2.svg";